import { render } from "./AnnouncementDetail.vue?vue&type=template&id=2226fa22&scoped=true"
import script from "./AnnouncementDetail.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetail.vue?vue&type=script&lang=js"

import "./AnnouncementDetail.vue?vue&type=style&index=0&id=2226fa22&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2226fa22"]])

export default __exports__